<template>
  <div  class="memberL">
    <pops :show="pop" :title="'选择开放范围'" @closePop="closePop" :width="'800px'">
      <div class="popScore">
        <div class="popContent">
          <div class="leftCont leftScope">
            <el-tabs v-model="activeType" @tab-click="_handleClick">
              <el-tab-pane label="常用组" name="first">
                <div class="rSearch">
                  <input v-model="groupName" class="_input" placeholder="请输入常用组名称搜索" type="text" @keyup.enter="getGroup">
                  <i class="point el-icon-search" @click="getGroup"></i>
                </div>
                <div class="listShow" v-loading="loading" >
                  <div class="check-group" :class="{'highColor':index === t}" v-for="(group,index) in usualGroups" @click="addClass(index)">
                      <span @click="getPeople(group,index)">{{group.groupName}}  ( {{group.total}} )</span>
                      <a class="check-group-a" @click="handleGroup(group)">添加</a>
                  </div>
                </div>
                <div class="peoples" v-loading="loading">
                   <div v-for="people in peoples"  class="check-people" @click="handleCheckUser(people)">
                    <b class="tName" ref="tName" :value="people.id">{{people.name}}</b> <em v-if="people.attebdType==0 && people.job != null || people.attebdType==1 && people.job != null " ref="tEm">（{{ people.job}}）</em>
                   </div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="本院" name="second">
                <div class="rSearch">
                  <input v-model="deptName" class="_input" placeholder="请输入本院科室名称搜索" type="text"  @keyup.enter="getOwnDept">
                  <i class="point el-icon-search" @click="getOwnDept"></i>
                </div>
                <div class="listShow" style="text-indent:10px">
                  <div class="check-group ownHos" v-if="OwnHos"><span @click="clickOwnHos">{{OwnhospitalName}}</span> <a class="check-group-a" @click="handleOwnHos" >添加</a></div>
                  <div class="check-group" :class="{'highColor':index === t}" v-for="(dept,index) in ownDepts" @click="addClass(index)">
                      <span @click="getOwnDeptPeople(dept,index)">{{dept.deptName}}  ( {{dept.total}} )</span>
                      <a class="check-group-a" @click="handleOwnDept(dept)">添加</a>
                  </div>
                </div>
                <div class="peoples" v-loading="loading">
                   <div v-for="doctors in ownDocs"  class="check-people" @click="handleDeptPeo(doctors)">
                   {{doctors.name}} <em v-if="doctors.job != null">（{{ doctors.job}}）</em>
                   </div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="按医院" name="third">
                <div class="rSearch">
                  <input v-model="hospitalName" class="_input" placeholder="请输入医院名称搜索" type="text" @keyup.enter="getHosp">
                  <i class="point el-icon-search" @click="getHosp"></i>
                </div>
                <div class="listShow" style="height:391px">
                <div class="check-group" v-for="(hsp,index) in allHospital">
                  <span>{{hsp.hosName}}</span>
                  <a class="check-group-a" @click="handleHospital(hsp,index)">添加</a>
                </div>
                    <div class="nodata" v-show="nodata">暂无数据</div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="按科室" name="fouth">
                <div class="rSearch">
                  <input v-model="deptsName" class="_input" placeholder="请输入科室名称搜索" type="text" @keyup.enter="getDept">
                  <i class="point el-icon-search" @click="getDept"></i>
                </div>
                <div class="listShow"  v-loading="loading">
                  <el-tree class="check-tree"
                    :data="data3"
                    ref="tree"
                    node-key="id"
                    @node-click="getDeptDocs"
                    default-expand-all
                    :default-expanded-keys="parKeyId"
                    :props="defaultProps"
                    :expand-on-click-node="false">
                       <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>
                        <a class="check-tree-a" v-if="nodeShow" @click="handleDept(data)">添加</a>
                       </span>
                  </el-tree>
                </div>

                <div class="peoples" v-loading="loading">
                   <div v-for="doctor in otherDocs"  class="check-people" @click="handleDeptPeo(doctor)">
                   {{doctor.name}} <em v-if="doctor.job != null">（{{ doctor.job}}）</em>
                   </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="rightCont">
            <div class="rightTitle">
              <span class="alreadyChoose">已选择:</span>
              <span class="saveAs" @click="_saveData">保存为常用组</span>
            </div>
            <div class="borderCont">
              <ul class="rtHeight overtHeight">
                <li  class="rightList"  v-for="(item,index) in checkedList" :class="{'':item.txtColor==0,'txt-yellow':item.txtColor==3,'txt-navy':item.txtColor==2,'txt-green':item.txtColor==1}"
                :value="item.id" :label="item.name" :type="item.attebdType">
                <span>{{item.name}}</span><em v-if="item.attebdType==0 && item.job != null || item.attebdType==1 && item.job != null">{{item.job}}</em>
                <i class="closeBtn" @click="_closeBtn(index)">删除</i>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--确定取消按钮-->
        <div class="btn-box">
          <el-button @click="_saveDepert" class="save">确定</el-button>
          <el-button @click="_cancelHos" class="cancel">取消</el-button>
        </div>
      </div>
    </pops>
    <!--保存为常用组-->
    <pops :show="popSaveData" :title="'保存常用组'" @closePop="closeSaveData" :width="'50%'">
      <div class="popScore">
        <el-form label-width="100px">
          <el-row>
            <el-col :span="22">
              <el-form-item :span="10" label="名称  :" prop="CurseName">
                <el-col :span="24">
                  <el-input v-model="GroupName" :maxlength="10" placeholder="请输入名称"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="saveMember">
            <el-col :span="22">
              <el-form-item :span="10" label="组员  :">
                <el-col :span="24">
                  <div class="memberTrue" v-model="groupMembers">{{member}}</div>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!--确定取消按钮-->
        <div class="btn-box">
          <el-button @click="_saveCourseName(groupMembers)" class="save commonBtn">确定</el-button>
          <el-button @click="_cancelGroup" class="cancel commonBtn">取消</el-button>
        </div>
      </div>
    </pops>
  </div>
</template>

<script type="text/ecmascript-6">
  import pops from '@/components/common/pops/pop'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import {message} from '@/common/js/messages'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'

  export default {
    components: {
      pops
    },
    data() {
      return {
        pop: false,
        popSaveData: false,
        loading: false,
        founder: '',
        OwnhospitalName:'',
        activeType: 'first',
        t:'',
        // 保存常用组
        member:'',
        examinName:'',
        groupName:'',
        GroupName:'',
        groupMembers:[],
        examin:{},
        // 常用组
        active:false,
        peoples: [],
        usualGroups:[],
        groupCheckList: [],
        peoCheckList: [],
        //本院
        deptName:'',
        ownDepts:[],
        ownDocs:[],
        OwnHos:false,
        //按医院
        nodata:true,
        hospitalName: '',
        allHospital:[],
        hsp:false,
        //按科室
        nameloading: false,
        deptsName:'',
        data3: [],
        parKeyId:[],
        otherDocs:[],
        nodeShow:true,

        checkedList:[],
        openMemberList: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
      }
    },
    watch: {
      activeType(val) {
        if (val === 'first'){
          this.getGroup()
        }
      }
    },
    mounted() {
     // let tnameWidth = this.$refs.tName.style.width
     // this.$refs.tEm.style.width = tnameWidth +'px'
    },
    methods: {
      closePop() {
        this.pop = false
      },
      closeSaveData() {    //常用组弹框关闭
        this.popSaveData = false
      },
      _handleClick(tab) {    //科室常用组切换
        this.tabLabel = tab.label
        if(tab.label==='常用组') {
          // this._getGroup()
          // this.addClass(group,index)
        }else if(tab.label==='本院'){
          // this.addClass(dept,index)
        }else if(tab.label==='按医院'){
          // this.getHosp()
        }else if(tab.label==='按科室'){

        }
      },
      addClass(index){
        this.t = index
      },
      openFlag(){   //开放范围打开弹框
        this.pop = true
        this.checkedList = []    //
        // console.log(this.openMemberList)
        if(this.openMemberList.length!==0){
          for (let item of this.openMemberList) {
            // console.log(item)
            this.checkedList.push({
              id: item.id,
              name: item.name,
              job: item.job,
              txtColor:item.txtColor,
              attebdType: item.attebdType
            })
          }
        }
        this.getGroup()  //载入时获取
        this.getOwnDept()
        this.getHosp()
        this.getDept()
      },
      getGroup(group) {    //获取常用组列表
        let params = {
          groupName: this.groupName
        }
        http.post('/system/getMeteriaGroupList.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.loading = false
              if (res.data.model === [] ){
                this.nodata = true
              }else{
                this.nodata = false
                 this.usualGroups = res.data.model
              }
          } else {
          }
        })
      },
      getPeople(group){  //获取常用组人员

        this.active = true

          let params = {
              id:group.id
          }
          http.post('/system/getGroupMembers.json', params).then(res => {
            if (res.data.code === _.ERR_OK) {
              this.loading = false
              this.nodata = false
              let arr = res.data.model
              this.peoples = []
              arr.forEach(ele => {
                this.peoples.push({
                  id: ele.userId ||  ele.deptId ||  ele.hosId,
                  name:ele.docName ||  ele.deptName ||  ele.hosName,
                  job: ele.docTitle || ele.hosName,
                  attebdType:ele.attendType
                })
              })

            }else{
              message(res.data.msg, false)
            }
          })
      },
      getOwnDept(dept) {      //本院科室列表
        this.loading = true
        this.OwnHos = true
        let params = {
          deptName: this.deptName,
          hosId: this.hospitalId
        }
        http.post('/system/queryDeptsByHosid.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
              this.loading = false
              if (res.data.model === [] ){
                this.nodata = true
              }else{
                this.nodata = false
                 this.ownDepts = res.data.model
              }
          } else {
            this.loading = false
            // message(res.data.msg, false)
          }
        })
      },
      getOwnDeptPeople(dept){   //获取常用组人员
          let params = {
              deptId:dept.deptId
          }
          http.post('/system/queryDocByDeptid.json', params).then(res => {
            if (res.data.code === _.ERR_OK) {
              this.loading = false
              let arr = res.data.model
              this.ownDocs = []
              arr.forEach(ele => {
                this.ownDocs.push({
                  id: ele.doctorId,
                  name:ele.doctorName,
                  job: ele.docTitle || ele.hosName,
                  attebdType:ele.attendType
                })
              })

            }else{
              message(res.data.msg, false)
            }
          })
      },
      getHosp() {        //获取医院
        this.loading = true
        let params = {
          hosName:this.hospitalName,
          flag:2
        }
        http.post('/system/getHospitalList.json', params).then(res => {
           if (res.data.code === _.ERR_OK) {
            this.loading = false
              if (res.data.model === [] ){
                this.nodata = true
              }else{
                this.nodata = false
                this.allHospital = res.data.model
              }
           } else {
            this.loading = false
            message(res.data.msg, false)
           }
        })
      },
      getDept() {      //获取医院+科室
        this.loading = true
        let params = {
          deptName: this.deptsName
        }
        http.post('/system/getMembersByDeptId.json', params).then(res => {
          if (res.data.code === "SUCCESS") {
             this.loading = false
              var arr = res.data.model
              var map = {}
              var dest = []
              arr.forEach(ele => {
                let e = map[ele.hosId]
                if (!e) {
                e = {id: ele.hosId, label: ele.hosName, disabled: true}
                map[ele.hosId] = e
                e.nodeShow = false
                dest.push(e)
                }
                e.children = e.children || []
                e.children.push({id: ele.deptId, label: ele.deptName+'（ '+ele.total+' ）', deptId: ele.deptId})
              })
              this.data3 = dest
          } else {
            // this.$refs.deptsPeople = false
            this.loading = false
            message(res.data.msg, false)
          }
        })

      },
      getDeptDocs() {
        let theId = this.$refs.tree.getCurrentKey()
        let fatherId = this.$refs.tree.getNode(theId).parent.data.id
        let child = this.$refs.tree.getNode(theId).data.children


        // console.log(child)
        if(child != undefined){
            this.otherDocs = []
            return false
        }else{
          let params = {
              hosId:fatherId,
              deptId:theId
          }
          http.post('/system/queryDocByDeptOrHosId.json', params).then(res => {
            if (res.data.code === _.ERR_OK) {
              this.loading = false
              let arr = res.data.model
              this.otherDocs = []
              arr.forEach(ele => {
                this.otherDocs.push({
                  id: ele.doctorId,
                  name:ele.doctorName,
                  deptId:ele.deptId,
                  job: ele.docTitle || ele.hosName,
                  attebdType:ele.attendType
                })
              })
            }else{
              message(res.data.msg, false)
              this.otherDocs = []
            }
          })
        }


      },
      handleDept(data){ //科室 列表勾选
        let [id, label] = [data.id, data.label];
        let theId = this.$refs.tree.getCurrentKey()
        //let faterHos = this.$refs.tree.getNode(theId).parent.data.label.toString()
        let faterHos = this.$refs.tree.getNode(data.id).parent.data.label.toString()
        let labelResult = label.match("[\u4e00-\u9fa5]+").toString() //匹配科室中的中文 去除括号及数字
        // console.log(labelResult)

        this.checkedList.push({id:id,name:labelResult,job:faterHos,txtColor:1,attebdType:1})
      },
      handleDeptPeo(doctors) {    //科室人员勾选
        this.checkedList.push({id:doctors.id,name:doctors.name,job:doctors.job,txtColor:0,attebdType:0})
      },
      clickOwnHos(){
        this.ownDocs = []
      },
      handleOwnHos(){
         this.checkedList.push({id:this.hospitalId,name:this.OwnhospitalName,job:null,txtColor:2,attebdType:2})
      },
      handleOwnDept(dept){ //本院科室 勾选
        let ksList = []

          this.checkedList.forEach(i =>{
            let deptID = i.id
            let aList = ""
            aList += deptID
            ksList = [aList]
          })

          // if(ksList.indexOf('95710002') > -1 ){
          //   message('您已选择了本院全院，请勿重复添加科室')
          //   return
          // } else {
            this.checkedList.push({id:dept.deptId,name:dept.deptName,job:null,txtColor:1,attebdType:1})
          // }
      },

      handleHospital(hsp){ //医院勾选
        this.checkedList.push({id:hsp.hosId,name:hsp.hosName,txtColor:2,attebdType:2})
      },
      handleGroup(group){ //常用组 列表勾选
          // if ( group.checked == true ) {
            group.txtgreen = true
            this.checkedList.push({id:group.id,name:group.groupName,txtColor:3,attebdType:3})
          // } else {
          //     for (let i in this.checkedList) {
          //       if ( this.checkedList[i].id === group.id ){
          //         // alert(this.checkedList[i].id)
          //       this.checkedList.splice(i, 1)
          //       break
          //       }
          //     }
          // }
      },
      handleCheckUser(people) {    //常用组 人员勾选
              this.checkedList.push({
                id:people.id,
                name:people.name,
                attebdType:people.attebdType,
                job:people.job,
                txtColor:people.attebdType
              })
      },
      _closeBtn(index) {    //选中人员删除
        let e = this.checkedList.splice(index, 1)[0]
      },
      _saveData() {    //保存为常用组
        // console.log(this.checkedList)
      this.GroupName = ''
      if(this.checkedList.length != '0'){
        let examineName = ''
        let aList = ''
          for(let i of this.checkedList){
            let aT = i.attebdType.toString()
            aList += aT
          }
          // console.log(aList)
          if(aList.indexOf('3') > -1 ){
            this.groupMembers = []
            this.popSaveData == false
            message('常用组不能保存为常用组，请重新选择')
            return
          } else if (aList.indexOf('3') === -1 ){
            this.popSaveData = true
            this.groupMembers = []
            this.checkedList.forEach( ele => {
              this.groupMembers.push({
                attendType:ele.attebdType,
                fullId: ele.id,
                docName:ele.name
              })
            })
          }

        this.examin = JSON.stringify(this.groupMembers)
          for( let item of this.groupMembers){
            let names = item.docName
              examineName += names +"， "
              this.member =  examineName
          }
      }else{

        message('已选择列表为空，无法保存常用组')
      }


      },
      _saveDepert() {   //选中人员确定
        if(this.checkedList.length!==0) {
          this.pop = false
          var examinePart = "";
          for (let item of this.checkedList) {
            examinePart +="，" + item.name;
            if (examinePart.substr(0,1)=='，')
              examinePart=examinePart.substr(1);
          }
          this.$emit('openMemberVal', examinePart)
          var members = []
          for (let item of this.checkedList) {
            if(item.id!==undefined){
              members.push({
                userId: item.id,
                // name: item.name,
                attendType: item.attebdType,
                // job: item.job
              })
            } else {
              members.push({
                userId: item.id,
                // docName: item.name,
                attendType: item.attebdType,
                // job: item.job
                // userId: item.id,
                // docName: item.label,
                // deptId: item.deptId
              })
            }
          }
          this.openMemberList = this.checkedList
          this.$emit('openMemberData', members)
          message('选择开放范围成功', true)
        } else {
          message('未选择开放范围', false)
        }
      },
      _saveCourseName() {  //常用组保存确定
        let params = {
          groupName: this.GroupName,
          groupMembers: this.groupMembers
        }
        let jsonP = {"edugroup":JSON.stringify(params)}
        // 按后台要求数据格式传参，edugroup无意义
        http.post('/system/addCommonGroup.json', jsonP).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.popSaveData = false
            message("保存成功", true)
          } else {
            message(res.data.msg, false)
          }
        }).catch(err => {
        })
      },
      getUserInfo() {    //获取用户信息
        http.post('/getUserInfo.json').then(res => {
          if (res.data.code === _.ERR_OK) {
            this.hospitalId = res.data.model.hosId
            this.OwnhospitalName = res.data.model.hosName
            this.founder = res.data.model.userName
            saveLocalStorage(res.data.model.userName, 'userName')
          }
        })
      },
      _cancelHos() {   //科室弹框取消
        this.pop = false
      },
      _cancelGroup() {  //常用组弹框取消
        this.popSaveData = false
      },
      openFlagPop(val){
        alert(val)
      }
    },
    created() {

      this.getUserInfo()
      let isModify = getLocalStorage('isModify')
      if(isModify) {
        // this.checkedList = []
          let detailData = getLocalStorage('bianjiData')

          let Meter = []
          let par = {}
          // console.log(detailData.attendList)
          for (let item of detailData.attendList) {
           if(item.attendType == '3'){
            par = {
              id: item.groupId,
              name: item.groupName,
              job: '',
              attebdType: item.attendType,
              txtColor: 3
            }
           }else if(item.attendType =='2'){
            par = {
              id: item.hosId,
              name: item.hosName,
              job: '',
              attebdType: item.attendType,
              txtColor: 2
            }
           }else if(item.attendType =='1'){
            par = {
              id: item.deptId,
              name: item.deptName,
              job: item.hosName,
              attebdType: item.attendType,
              txtColor: 1
            }
           }else{
            par = {
              id: item.userId,
              name: item.userName,
              job: item.docTitle,
              attebdType: item.attendType,
              txtColor: 0
            }
           }
            Meter.push(par)
            // this.checkedList = Meter
            this.openMemberList = Meter
          }

      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .el-checkbox+.el-checkbox
    margin-left:0 !important
  .txt-yellow
    color $color-deepyellow
  .txt-navy
    color $color-darkblue
  .txt-green
    color $color-green
  .highColor
    background:#f7f8fa
  .nodata
    width  100%
    height 100%
    display flex
    align-items:center
    justify-content: center;



  .rSearch
    position: relative
    margin-bottom: 10px
  .point
    position: absolute
    right: 20px
    top: 5px
  ._input
    min-width: 200px
    width: 100%
    background: #f2f2f2
    height: 24px
    border-radius: 20px
    right: 20px
    top: -14px
    padding: 0 20px
    box-sizing: border-box;
  .memberTrue
    line-height: 26px !important
    border: 1px solid #dcdfe6
    height: 300px
    overflow-y: auto
    overflow-x: hidden
  .overtHeight
    height: 100%
  .rtHeight
    overflow-y: auto
  .rightList
    width: 100%
    span
      display inline-block
      line-height 20px
      max-width: 210px
      overflow:hidden
      white-space:nowrap
      text-overflow:ellipsis
    .closeBtn
      display: inline-block
      font-size: 12px
      text-align: right
      border-radius: 50%
      float right
      color: $title-color
      cursor: pointer
      &:hover
        color:$color-green
  .listShow
    height 240px
    overflow-y auto
  .check-group
    width: 100%
    cursor pointer
    line-height 24px
    span
      display inline-block
      width 300px
      text-indent 10px
      text-overflow ellipsis
      white-space nowrap
    a
      display none
      width 40px
      text-align center
    &:hover
      // color:$color-green
      background  #f7f8fa
      a
        display inline-block
    &.ownHos
      span
        text-indent 0

  .check-group-a
    font-size: 12px;
    float:right;

  .check-tree
    cursor pointer
    .custom-tree-node
      width calc(100% - 30px )
      a
        display none
        font-size: 12px;
        float right
        width 40px
        text-align center
    .el-tree-node__content:hover
      a
        display block
        float right


  .peoples
    margin-top: 10px
    padding:5px
    overflow-y auto
    width: calc(100% - 12px)
    height:130px
    border 1px solid $border-color
    .check-people
      width: 49%
      margin-left 1%
      float left
      line-height 20px
      cursor pointer
      &:hover
        color:$color-green
      &:nth-child(2n)
        margin-right 0
      b
        display: inline-block;
      em
        font-style: normal;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow:hidden
        vertical-align top
        max-width 60%
        color $color-maingrey
        display: inline-block;
        font-size: 12px;

  .btn-box
    text-align: center
    margin: 15px 0 0
    .save, .cancel
      width: 180px
      height: 35px
      border: none
      color: $button-text-color
    .save
      background: $color-background-hover
      margin-right: 80px
    .commonBtn
      width: 90px
    .cancel
      background: $button-del
  .popScore
    .el-collapse
      height: 300px
      overflow-y: auto
    .el-tree
      height: 240px;
      overflow-y: auto;
    .popContent
      height: 495px
      position: relative
      overflow: hidden
      .leftCont
        width: 52%
        height: 100%
        float: left
        padding-left: 10px
      .rightCont
        width: 40%
        height: 100%
        float: right
        padding-right: 10px
        .rightTitle
          height: 40px
          line-height: 40px
          .alreadyChoose
            float: left
            font-weight: 900
          .saveAs
            float: right
            color: #faab2d
            cursor: pointer
        .borderCont
          border: 1px solid $border-color
          width: 100%
          height: 441px
          padding: 10px
          box-sizing: border-box
          em
            color $color-maingrey
            font-size:  12px
            margin-left 10px
            line-height: 20px
            font-style normal
            display: inline-block;
            vertical-align: top;
</style>



// WEBPACK FOOTER //
// openFlagPop.vue?36a7b811